export default "__VITE_ASSET__18f65349__"